const GET_TOKEN_START = 'GET_TOKEN_START';
const GET_TOKEN_START_SUCCESS = 'GET_TOKEN_START_SUCCESS';

const GET_OPPORTUNITY_DATA_START = 'GET_OPPORTUNITY_DATA_START';
const GET_OPPORTUNITY_DATA_SUCCESS = 'GET_OPPORTUNITY_DATA_SUCCESS';
const GET_OPPORTUNITY_DATA_ERROR = 'GET_OPPORTUNITY_DATA_ERROR';

const SET_CURRENT_STATUS = 'SET_CURRENT_STATUS';

const getTokenAction = () => {
	return {
		type: GET_TOKEN_START
	};
};

const getTokenActionSuccess = (res) => {
	return {
		type: GET_TOKEN_START_SUCCESS,
		res
	};
};

const getOpportunityInfoStart = (history, optId, isLandingPageClick = false) => {
	return {
		type: GET_OPPORTUNITY_DATA_START,
		history,
		optId,
		isLandingPageClick
	};
};

const setCurrentStatus = () => {
	console.log('USER ACCTION');
	return {
		type: SET_CURRENT_STATUS
	};
};

const getOpportunityInfoSuccess = (res) => {
	return {
		type: GET_OPPORTUNITY_DATA_SUCCESS,
		res
	};
};

const getOpportunityInfoError = () => {
	return {
		type: GET_OPPORTUNITY_DATA_ERROR,
	};
};


export default {
	types: {
		GET_TOKEN_START,
		GET_TOKEN_START_SUCCESS,

		GET_OPPORTUNITY_DATA_START,
		GET_OPPORTUNITY_DATA_SUCCESS,
		GET_OPPORTUNITY_DATA_ERROR
	},
	creators: {
		getTokenAction,
		getTokenActionSuccess,
		getOpportunityInfoStart,
		getOpportunityInfoSuccess,
		getOpportunityInfoError,
		setCurrentStatus
	},
};
